module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    attrs: {
      "visible": _vm.dialogVisible,
      "title": "Select random winners"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('p', [_vm._v("\n    This will allow you to select a set of random winners for your campaign.\n    It will randomly select a set of messages that was sent into this campaign based on\n    the parameters you define below.\n  ")]), _vm._v(" "), _c('el-form', {
    attrs: {
      "label-width": "120px",
      "model": _vm.form,
      "rules": _vm.rules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "File name",
      "prop": "fileName"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form.fileName),
      callback: function($$v) {
        _vm.$set(_vm.form, "fileName", $$v)
      },
      expression: "form.fileName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Dates",
      "prop": "rangeDate"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "datetimerange",
      "range-separator": "To",
      "start-placeholder": "Start date",
      "end-placeholder": "End date",
      "picker-options": _vm.pickerOptions
    },
    model: {
      value: (_vm.form.rangeDate),
      callback: function($$v) {
        _vm.$set(_vm.form, "rangeDate", $$v)
      },
      expression: "form.rangeDate"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Winners",
      "prop": "winners"
    }
  }, [_c('el-input-number', {
    model: {
      value: (_vm.form.winners),
      callback: function($$v) {
        _vm.$set(_vm.form, "winners", $$v)
      },
      expression: "form.winners"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Unique",
      "prop": "uniqueWinners"
    }
  }, [_c('el-switch', {
    model: {
      value: (_vm.form.uniqueWinners),
      callback: function($$v) {
        _vm.$set(_vm.form, "uniqueWinners", $$v)
      },
      expression: "form.uniqueWinners"
    }
  })], 1)], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "disabled": _vm.isLoading
    },
    on: {
      "click": _vm.handleCancel
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "disabled": _vm.isLoading
    },
    on: {
      "click": _vm.handleRunRandomSelection
    }
  }, [_c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLoading),
      expression: "isLoading"
    }],
    staticClass: "fa fa-spinner fa-spin"
  }), _vm._v("\n      Select\n    ")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-174bf314","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"multiple":[{"search":"logo-white[.]svg","replace":"logo-white-live.svg","flags":"g"},{"search":"_variables","replace":"_variables_live","flags":"g"},{"search":"_theme","replace":"_live","flags":"g"}]}!./src/components/campaign/RandomSelectDialog.vue
// module id = 3157
// module chunks = 3